import React from "react";
// Zerodha landing page AboutPage component
import Hero from "./Hero";
import Team from "./Team";

function PricingPage() {
  return (
    <>
      <Hero />
      <Team />
    </>
  );
}

export default PricingPage;